import { useCallback } from "react";
import { trackDashboardCtaClicked } from "analytics";
import NextMoveCard from ".";
import Translate from "translate/Translate";
import { SHOW_ALL_NEXT_MOVE_CARDS } from "./showAllNextMoveCards";
import { useNextMoveMemberContext } from "./useNextMoveMemberContext";

const NavigationTeamNextMoveCard = () => {
  const { memberNeedsToTalkToNav } = useNextMoveMemberContext();

  const onActionClick = useCallback(() => {
    trackDashboardCtaClicked({
      workflow: "dashboard",
      ctaLocation: "next_move_card",
      ctaId: "navigation_team"
    });
  }, []);

  if (!SHOW_ALL_NEXT_MOVE_CARDS && !memberNeedsToTalkToNav) {
    return null;
  }

  return (
    <NextMoveCard
      id="contact-navigation-team-next-move"
      tag="inProgress"
      title={<Translate text="Connect with the navigation team" />}
      body={
        <Translate text="Based on what you've shared, we suggest that you talk with a member of our navigation team. They can provide in-depth 1-on-1 support tailored to your unique needs." />
      }
      subBody={
        <Translate text="A member of our navigation team will reach out to you soon." />
      }
      link={{
        onClick: onActionClick,
        overrideClick: true,
        url: "#"
      }}
    />
  );
};

export default NavigationTeamNextMoveCard;
